var map = {
	"./033-bm.webp": 1166,
	"./033-cn.webp": 1167,
	"./033.webp": 1168,
	"./13-bm.webp": 1169,
	"./13-cn.webp": 1170,
	"./13.webp": 1171,
	"./3-bm.webp": 1172,
	"./3-cn.webp": 1173,
	"./3.webp": 1174,
	"./angpao-bg-mobile.webp": 1175,
	"./angpao-bg.webp": 1176,
	"./angpao-bm.webp": 1177,
	"./angpao-cn.webp": 1178,
	"./angpao.webp": 1179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1165;